module.exports = __webpack_public_path__ + "static/media/2019-Mustang-Coupe-V8.77114613.webp";